import { gql } from '@apollo/client'
import { ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT } from '../fragments'

export const GET_RETIRED_USERS_FOR_ZONE = gql`
  query GetRetiredUsersForZone($input: CompanyUsersInput!) {
    retiredUsersForZone(input: $input) {
      results {
        fullName
        email
        mainRole
        zone {
          ...ZoneHierarchyGlobalSearchResult
        }
      }
    }
  }
  ${ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT}
`
